export const zhCN = {
  // Navigation
  nav: {
    ats: "人才管理系统",
    jobPostings: "职位管理", 
    candidates: "候选人",
    signIn: "登录",
    signOut: "退出",
    postJob: "发布职位",
    findJobs: "找工作",
    companies: "公司",
    jobAlerts: "职位提醒",
    superAdmin: "超级管理员"
  },

  // Hero Section
  hero: {
    title: "找到理想工作\n在斯里兰卡",
    subtitle: "与顶级雇主建立联系，在全国首个AI驱动的求职平台上发现数千个机会",
    searchPlaceholder: "职位名称或关键词",
    locationPlaceholder: "选择地点",
    jobTypePlaceholder: "工作类型",
    searchButton: "搜索职位",
    stats: {
      activeJobs: "活跃职位",
      companies: "合作公司", 
      jobSeekers: "求职者"
    }
  },

  // Job Card
  jobCard: {
    applyNow: "立即申请",
    remote: "远程",
    ago: "前",
    salary: "薪资"
  },

  // Features Section
  features: {
    title: "为什么选择GreatJobs.lk？",
    subtitle: "斯里兰卡最值得信赖的求职平台，连接人才与机遇。",
    topCompanies: {
      title: "顶级公司",
      description: "获得斯里兰卡领先雇主的工作机会"
    },
    aiMatching: {
      title: "人工智能匹配",
      description: "候选人与工作机会的智能匹配"
    },
    careerGrowth: {
      title: "职业发展",
      description: "找到推进您职业发展的机会"
    },
    qualityVerified: {
      title: "质量认证",
      description: "所有职位发布都经过验证且合法"
    }
  },

  // Quick Start Section
  quickStart: {
    getStarted: "几秒钟即可开始",
    payment: "信用卡或加密货币支付",
    getStartedDesc: "创建账户并立即开始申请工作",
    paymentDesc: "满足您所有招聘需求的灵活支付选项"
  },

  // Featured Jobs Section
  featuredJobs: {
    title: "精选职位",
    subtitle: "发现来自顶级雇主的优质机会",
    viewAll: "查看所有职位",
    noJobs: "目前暂无精选职位。"
  },

  // CTA Section
  cta: {
    title: "准备好将您的职业生涯提升到新高度吗？",
    subtitle: "加入数千名通过GreatJobs.lk找到理想工作的专业人士。",
    createAccount: "创建求职者账户",
    postFirstJob: "发布您的第一个职位"
  },

  // Footer
  footer: {
    description: "斯里兰卡首屈一指的求职门户，连接人才与机遇。",
    jobSeekers: "求职者",
    employers: "雇主", 
    support: "支持",
    browseJobs: "浏览职位",
    careerAdvice: "职业建议",
    resumeBuilder: "简历制作",
    postJobs: "发布职位",
    searchCandidates: "搜索候选人",
    atsIntegration: "ATS集成",
    pricing: "定价",
    helpCenter: "帮助中心",
    contactUs: "联系我们",
    privacyPolicy: "隐私政策",
    termsOfService: "服务条款",
    yourSafety: "您的安全",
    copyright: "版权所有。"
  },

  appliedJobs: {
    title: "已申请职位",
    description: "追踪和管理您的所有工作申请",
    noApplications: "未找到申请记录",
    noApplicationsDescription: "您还没有申请任何职位。开始探索机会吧！",
    searchPlaceholder: "按职位标题、公司或地点搜索...",
    filterByStatus: "按状态筛选",
    allStatus: "所有状态",
    pending: "待审核",
    shortlisted: "入围",
    interviewing: "面试中",
    offerMade: "已发出聘用通知",
    rejected: "已拒绝",
    withdrawn: "已撤回",
    appliedAgo: "申请于",
    match: "匹配度",
    coverLetter: "求职信",
    cvAttached: "简历已附",
    viewJob: "查看职位",
    downloadCv: "下载简历",
    withdraw: "撤回",
    withdrawing: "撤回中...",
    withdrawTitle: "撤回申请",
    withdrawDescription: "您确定要撤回对\"{jobTitle}\"的申请吗？此操作无法撤销。",
    withdrawSuccess: "申请已成功撤回",
    withdrawError: "撤回申请失败",
    loadError: "加载您的申请记录失败",
    browseJobs: "浏览职位",
    previous: "上一页",
    next: "下一页",
    pageOf: "第 {current} 页，共 {total} 页",
    remote: "远程"
  },

  // Job Management
  jobManagement: {
    title: "职位管理",
    subtitle: "管理您的职位发布并跟踪效果",
    postNewJob: "发布新职位",
    noJobsTitle: "尚无职位发布",
    noJobsDescription: "开始发布您的第一个职位",
    postFirstJob: "发布您的第一个职位",
    view: "查看",
    edit: "编辑",
    delete: "删除",
    aiMatch: "AI匹配",
    applications: "申请",
    posted: "发布于",
    salary: "薪资",
    salaryNotSpecified: "薪资待议",
    jobDetails: "职位详情",
    description: "职位描述",
    requirements: "任职要求",
    benefits: "福利待遇",
    skills: "技能要求",
    deleteConfirmTitle: "删除职位发布",
    deleteConfirmDescription: "您确定要删除此职位发布吗？此操作无法撤销。",
    cancel: "取消",
    confirm: "删除",
    deleteSuccess: "职位发布删除成功",
    deleteError: "删除职位发布失败",
    aiMatchingTitle: "AI匹配候选人",
    aiMatchingSubtitle: "使用人工智能匹配的顶级候选人",
    upgradeRequired: "需要升级",
    aiMatchingUpgradeMessage: "AI匹配功能仅适用于BPO批量计划和企业年度计划",
    matchPercentage: "匹配度",
    experience: "经验",
    viewCV: "查看简历",
    years: "年",
    noMatchedCandidates: "未找到匹配的候选人",
    fetchingCandidates: "正在获取合适的候选人...",
    fetchCandidatesError: "获取合适候选人失败",
    loadingJobs: "加载职位列表中...",
    fetchJobsError: "获取职位列表失败"
  },

  // ATS (Applicant Tracking System)  
  ats: {
    title: "申请人跟踪系统",
    subtitle: "管理申请和入围候选人",
    jobApplications: "职位申请",
    shortlistedCandidates: "入围候选人",
    selectJobListing: "选择职位",
    allApplications: "所有申请",
    pending: "待处理",
    reviewing: "审核中",
    shortlisted: "入围",
    rejected: "拒绝",
    hired: "已录用",
    loadingApplications: "加载申请中...",
    noApplicationsFound: "此筛选条件下未找到申请",
    match: "匹配",
    calculateMatch: "计算匹配度",
    appliedOn: "申请于",
    viewApplication: "查看申请",
    viewCV: "查看简历",
    updateStatus: "更新状态",
    addNotes: "添加备注",
    notesPlaceholder: "为此申请添加备注...",
    updateStatusSuccess: "申请状态已更新为",
    updateStatusError: "更新申请状态失败",
    matchCalculateSuccess: "匹配度计算完成：",
    matchCalculateError: "匹配度计算失败",
    openCVError: "打开简历失败",
    coverLetter: "求职信",
    candidateName: "候选人姓名",
    contactedOn: "联系时间",
    notContacted: "未联系",
    sample: "示例",
    fetchJobsError: "获取您的职位发布失败",
    fetchApplicationsError: "获取申请失败",
    shortlistedCandidatesCount: "入围候选人",
    searchMoreCandidates: "搜索更多候选人",
    noShortlistedTitle: "尚无入围候选人",
    noShortlistedDescription: "使用候选人搜索功能查找并入围潜在候选人。",
    searchCandidates: "搜索候选人",
    shortlistedOn: "入围于",
    experience: "经验",
    notice: "通知期",
    keySkills: "核心技能",
    notes: "备注",
    viewProfile: "查看资料",
    contacted: "已联系",
    contact: "联系",
    contactSuccess: "候选人联系成功",
    contactError: "更新联系状态失败",
    cvAvailable: "简历可用",
    years: "年"
  },

  // Candidate Search
  candidateSearch: {
    title: "搜索筛选器",
    requiredFields: "必填：输入（职位名称 + 经验水平）或 技能/关键词",
    jobTitle: "职位名称",
    jobTitlePlaceholder: "例如：软件工程师",
    experienceLevel: "经验水平",
    experienceLevelPlaceholder: "选择经验水平",
    skillsKeywords: "技能/关键词",
    skillsPlaceholder: "例如：React, Node.js, Python",
    additionalFilters: "附加筛选器（可选）",
    candidateName: "候选人姓名",
    candidateNamePlaceholder: "输入姓名...",
    availableOverseas: "可海外工作",
    availabilityPlaceholder: "选择可用性",
    visaStatus: "签证状态",
    visaStatusPlaceholder: "选择签证状态",
    searchCandidates: "搜索候选人",
    resetFilters: "重置筛选器",
    experienceLevels: {
      entry: "入门级",
      mid: "中级",
      senior: "高级",
      lead: "主管/经理",
      executive: "高管"
    },
    availability: {
      all: "全部",
      yes: "是",
      no: "否"  
    },
    visaStatuses: {
      all: "全部",
      citizen: "公民",
      permanent_resident: "永久居民",
      work_visa: "工作签证",
      student_visa: "学生签证",
      tourist_visa: "旅游签证",
      none: "无签证"
    },
    readyToSearch: "准备搜索候选人",
    searchInstruction: "输入职位名称和经验水平，或技能/关键词开始搜索。",
    searchError: "请输入（职位名称 + 经验水平）或 技能/关键词进行搜索",
    loadingAuth: "正在加载认证...",
    redirecting: "重定向中...",
    shortlist: "入围",
    contact: "联系",
    viewCV: "查看简历",
    shortlisted: "已入围",
    contacted: "已联系",
    years: "年",
    experience: "经验",
    keySkills: "核心技能",
    location: "地点",
    overseas: "海外",
    visa: "签证",
    noResults: "未找到候选人",
    searchErrorMessage: "搜索候选人失败"
  },

  // Post Job
  postJob: {
    jobDetails: "职位详情",
    unlimitedJobs: "无限职位",
    jobsUsed: "已使用职位",
    company: "公司",
    selectCompany: "选择公司",
    newCompany: "新公司",
    createNewCompany: "创建新公司",
    cancel: "取消",
    companyLogo: "公司标志",
    uploadLogo: "上传标志",
    uploading: "上传中...",
    imageFormats: "PNG, JPG 最大 5MB",
    companyName: "公司名称 *",
    companyNamePlaceholder: "输入公司名称",
    website: "网站",
    websitePlaceholder: "https://company.com",
    industry: "行业",
    industryPlaceholder: "例如：科技、金融",
    companySize: "公司规模",
    selectSize: "选择规模",
    employees1to10: "1-10 名员工",
    employees11to50: "11-50 名员工",
    employees51to200: "51-200 名员工",
    employees201to500: "201-500 名员工",
    employees500plus: "500+ 名员工",
    companyDescription: "公司描述",
    companyDescriptionPlaceholder: "简要描述公司",
    createCompany: "创建公司",
    jobTitle: "职位名称 *",
    jobTitlePlaceholder: "例如：高级软件工程师",
    location: "地点 *",
    locationPlaceholder: "例如：科伦坡，斯里兰卡",
    jobType: "工作类型 *",
    selectJobType: "选择工作类型",
    fullTime: "全职",
    partTime: "兼职",
    contract: "合同工",
    internship: "实习",
    experienceLevel: "经验水平 *",
    selectExperienceLevel: "选择经验水平",
    entryLevel: "入门级",
    midLevel: "中级",
    senior: "高级",
    executive: "高管",
    minSalary: "最低薪资 (LKR/月)",
    minSalaryPlaceholder: "例如：50000",
    maxSalary: "最高薪资 (LKR/月)",
    maxSalaryPlaceholder: "例如：80000",
    remoteWork: "支持远程工作",
    urgentHiring: "标记为紧急招聘",
    urgentBadgeActive: "紧急标志已激活",
    addUrgentBadge: "添加紧急招聘标志",
    urgentPaymentNotice: "发布此紧急职位前您将被重定向到付款页面。",
    requiredSkills: "所需技能（逗号分隔）",
    skillsPlaceholder: "例如：React, Node.js, PostgreSQL",
    applicationDeadline: "申请截止日期",
    jobDescription: "职位描述 *",
    jobDescriptionPlaceholder: "描述职位、职责以及您的要求...",
    requirements: "要求",
    requirementsPlaceholder: "列出所需的资格、经验和技能...",
    benefits: "福利",
    benefitsPlaceholder: "列出福利、津贴和薪酬详情...",
    postJob: "发布职位",
    payAndPostUrgent: "付费并发布紧急职位",
    processing: "处理中...",
    jobPostingLimitReached: "职位发布限制已达到",
    limitReachedMessage: "您已在 {plan} 计划中使用了全部 {count} 个职位发布额度",
    upgradePlan: "升级计划",
    almostAtLimit: "即将达到限制",
    limitWarningMessage: "在您的 {plan} 计划中，还剩 {count} 个职位发布额度",
    viewUpgrades: "查看升级",
    loading: "加载中..."
  },

  // Payment & Checkout
  payment: {
    orderSummary: "订单摘要",
    selectedPlan: "已选择计划",
    planPrice: "计划价格：",
    addons: "附加功能：",
    addonsSubtotal: "附加功能小计：",
    billing: "账单：",
    duration: "持续时间：",
    total: "总计：",
    paymentDetails: "付款详情",
    billingEmail: "账单邮箱",
    selectPaymentMethod: "选择付款方式",
    creditCard: "信用卡",
    viaStripe: "通过 Stripe",
    usdt: "USDT",
    viaCoinbase: "通过 Coinbase",
    secureStripePayment: "通过 Stripe 安全付款",
    stripeDescription: "您的付款将通过 Stripe 安全处理",
    payWithUsdt: "使用 USDT 付款",
    coinbaseDescription: "由 Coinbase Commerce 提供的安全 USDT 付款",
    processing: "处理中...",
    proceedToPayment: "继续付款",
    termsNotice: "继续操作即表示您同意我们的服务条款和隐私政策。除非取消，否则您的订阅将自动续订。",
    loadingCheckout: "加载结账页面...",
    oneTimePayment: "一次性付款",
    perMonth: "每月",
    perYear: "每年",
    days: "天"
  },

  // Testimonials
  testimonials: {
    title: "为什么专业人士选择斯里兰卡第一个AI驱动的人才解决方案",
    subtitle: "加入成千上万通过斯里兰卡最受信赖的求职平台找到理想工作的专业人士",
    testimonial1: {
      name: "拉温杜·佩雷拉",
      role: "软件工程师",
      company: "技术流解决方案公司",
      content: "在两周内找到了我在科伦坡的理想IT工作！AI匹配功能非常棒 - 它让我找到了其他地方找不到的机会。这绝对是斯里兰卡最好的求职平台。"
    },
    testimonial2: {
      name: "萨曼莎·费尔南多",
      role: "财务主管", 
      company: "兰卡银行",
      content: "作为一名应届毕业生，我一直在努力寻找斯里兰卡的入门级金融工作。GreatJobs.lk的精准匹配帮助我在一家领先银行获得了第一份工作。这个平台真正了解雇主的需求。"
    },
    testimonial3: {
      name: "卡孙·席尔瓦",
      role: "人力资源经理",
      company: "创意数字公司", 
      content: "我们尝试过很多平台，但GreatJobs.lk作为斯里兰卡第一个AI求职平台脱颖而出，真正提供高质量的候选人。我们在这里发布的科伦坡IT职位获得了技术开发人员的最佳回应。"
    },
    testimonial4: {
      name: "妮玛丽·贾亚辛格",
      role: "市场营销专员",
      company: "增长实验室",
      content: "职位提醒系统很棒！我能实时收到相关机会的通知。这就是为什么它被认为是斯里兰卡最好的求职平台 - 用户体验无与伦比。"
    },
    testimonial5: {
      name: "查图拉·门迪斯",
      role: "数据分析师",
      company: "分析专业公司",
      content: "在传统求职网站上搜索了几个月后，我发现了GreatJobs.lk。几天内，我就安排了完全匹配我技能的科伦坡IT工作面试。AI技术真的有效！"
    },
    testimonial6: {
      name: "普里扬卡·威克拉马辛格",
      role: "财务分析师",
      company: "投资合伙公司",
      content: "开始职业生涯很有挑战性，直到我找到了这个平台。斯里兰卡入门级金融工作板块正是我所需要的。详细的职位描述和公司资料让申请变得容易多了。"
    }
  },

  // ATS Integration
  atsIntegration: {
    title: "内置完整ATS系统",
    subtitle: "为什么要与外部系统集成，当您可以拥有内置的一切所需功能？GreatJobs.lk 提供专为高效招聘设计的全面申请人跟踪系统。",
    badge: "无需外部ATS",
    builtInFeatures: {
      title: "几分钟内开始",
      description: "跳过复杂的集成和冗长的设置过程。使用我们直观的一体化平台立即开始招聘，该平台与您的业务需求一起成长。",
      postFirstJob: "发布您的第一个职位",
      browseCandidates: "浏览候选人",
      jobManagement: {
        title: "完整职位管理",
        description: "发布、编辑和管理职位列表，具有高级定位选项和实时分析"
      },
      candidateSearch: {
        title: "高级候选人搜索", 
        description: "通过AI驱动的匹配和过滤功能搜索数千名合格候选人"
      },
      applicantTracking: {
        title: "申请人跟踪",
        description: "跟踪申请、管理候选人管道，并与您的招聘团队协作"
      },
      analytics: {
        title: "招聘分析",
        description: "获得有关职位表现、候选人质量和招聘指标的详细见解"
      },
      notifications: {
        title: "智能通知",
        description: "自动向候选人发送有关申请状态更新和新机会的短信和电子邮件通知"
      },
      shortlisting: {
        title: "候选人入围",
        description: "使用笔记和评级系统保存和整理有前途的候选人"
      }
    },
    externalIntegrations: {
      title: "另外提供外部集成",
      description: "已经在使用外部ATS？没问题。我们还提供与领先平台的无缝集成。",
      benefits: {
        sync: {
          title: "即时同步",
          description: "GreatJobs.lk与您的ATS平台之间的实时数据同步"
        },
        security: {
          title: "安全数据传输", 
          description: "具有加密API连接的企业级安全性"
        },
        workflow: {
          title: "简化工作流程",
          description: "消除手动数据输入并缩短招聘时间"
        },
        compliance: {
          title: "合规就绪",
          description: "自动维护GDPR和本地合规标准"
        }
      }
    },
    supportedPlatforms: {
      title: "支持的ATS平台",
      description: "我们与领先的申请人跟踪系统集成，确保无缝的工作流程兼容性。",
      workday: {
        name: "Workday",
        description: "具有实时同步的完整HCM集成",
        features: ["候选人同步", "职位发布自动化", "分析集成"]
      },
      bamboohr: {
        name: "BambooHR",
        description: "一体化HR平台集成", 
        features: ["员工入职", "绩效跟踪", "文档管理"]
      },
      greenhouse: {
        name: "Greenhouse",
        description: "高级招聘软件连接",
        features: ["面试安排", "记分卡集成", "管道管理"]
      },
      lever: {
        name: "Lever", 
        description: "现代人才获取平台",
        features: ["CRM集成", "协作招聘", "数据分析"]
      },
      icims: {
        name: "iCIMS",
        description: "全面人才云解决方案",
        features: ["人才获取", "劳动力管理", "合规跟踪"]
      },
      smartrecruiters: {
        name: "SmartRecruiters",
        description: "企业招聘平台",
        features: ["全球招聘", "AI驱动匹配", "供应商管理"]
      }
    },
    cta: {
      title: "准备好集成您的ATS了吗？",
      description: "开始使用我们全面的集成平台，立即转变您的招聘流程。",
      signUp: "立即注册"
    }
  },

  // Common
  common: {
    loading: "加载中...",
    search: "搜索",
    location: "地点",
    jobType: "工作类型",
    experienceLevel: "经验水平",
    fullTime: "全职",
    partTime: "兼职", 
    contract: "合同工",
    freelance: "自由职业",
    internship: "实习",
    entry: "入门级",
    mid: "中级",
    senior: "高级",
    executive: "高管级",
    active: "活跃",
    paused: "暂停",
    closed: "关闭",
    remote: "远程"
  }
};